<template>
  <div class="assessment_resultDetail">
    <div class="assessment_resultDetail_header">
      <div class="assessment_resultDetail_header_left" @click="$router.push({ path: '/assessmentResult' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>

    <div class="assessment_resultDetail_main">
      <p class="title">未来十年，{{ child === 1 ? '孩子' : '您' }}的{{ disease_name }}发病风险如下所示：</p>
      <div id="myChart" class="myChart"></div>
      <p class="title">{{ child === 1 ? '孩子' : '您' }}目前属于：</p>
      <p class="state"><span>{{ list.risk_level }}</span>人群</p>
      <p class="title">{{ child === 1 ? '孩子' : '您' }}需要：</p>
      <p class="message" v-for="(item, index) in list.allconclusion" :key="index">{{ index + 1 }}、{{ item }}</p>
      <div v-if="scode.length > 0">
        <div class="btnBox" v-show="child !== 1">
          <Btn v-if="disease_name === '非胰岛素依赖型糖尿病'" :btnData="{text: '查看我的专属药物指南'}" @btnClick="$router.push({path: '/drugType/代谢与内分泌药物'})"></Btn>
          <Btn v-else-if="disease_name === 'ASCVD'" :btnData="{text: '查看我的专属药物指南'}" @btnClick="$router.push({path: '/drugType/心血管药物'})"></Btn>
          <Btn v-else-if="disease_name === '肝癌'" :btnData="{text: '查看我的饮酒基因'}" @btnClick="$router.push({path: '/talentType/饮食'})"></Btn>
          <Btn :btnData="{text: '查看我的运动基因'}" @btnClick="$router.push({path: '/talentType/运动'})"></Btn>
        </div>
        <div class="btnBox" v-show="child === 1">
          <Btn v-if="disease_name === '非胰岛素依赖型糖尿病'" :btnData="{text: '查看孩子的专属药物指南'}" @btnClick="$router.push({path: '/drugType/代谢与内分泌药物'})"></Btn>
          <Btn v-else-if="disease_name === 'ASCVD'" :btnData="{text: '查看孩子的专属药物指南'}" @btnClick="$router.push({path: '/drugType/心血管药物'})"></Btn>
          <Btn v-else-if="disease_name === '肝癌'" :btnData="{text: '查看孩子的饮酒基因'}" @btnClick="$router.push({path: '/talentType/饮食'})"></Btn>
          <Btn :btnData="{text: '查看孩子的运动基因'}" @btnClick="$router.push({path: '/talentType/运动'})"></Btn>
        </div>
      </div>
      <p class="review" @click="goToReview">重新测评</p>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import { Dialog } from 'vant'
export default {
  name: 'resultDetail',
  components: {
    Btn,
    Dialog
  },
  data () {
    return {
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      disease_name: this.$route.params.name,
      list: {},
      time: [],
      series: [],
      scode: ''
    }
  },
  methods: {
    getDetail () {
      this.util.get(this.api.assessment_risk_list + '?type=1&intotype=0&disease_name=' + this.disease_name, '', (success) => {
        this.list = success
        this.scode = success.scode
        if (this.scode.length > 0) {
          let token = this.util.getLS('access_token')
          for (let i in token) {
            if (this.scode === i) {
              this.util.setLS(this.api.access_token, token[i])
            }
          }
        }
        this.series = []
        let series = [] // 当前预测曲线
        let series1 = [] // 上次预测曲线
        let series2 = [] // 实际检测曲线
        let time = [] // 时间
        let hash = [] // 去重后的时间(临时数组)
        if (success.risk.all.length > 1) {
          for (let i = 0; i < success.risk.all.length; i++) {
            time.push((Object.keys(success.risk.all[i])).reverse())
          }
          let temp = [] // 临时数组
          time.map((item) => {
            item.map((item1) => {
              temp.push(item1)
            })
          })
          time = temp
          time.sort((a, b) => new Date(a) - new Date(b))
          for (let i = 0; i < time.length; i++) {
            if (hash.indexOf(time[i]) * 1 === -1) {
              hash.push(time[i])
            }
          }
          this.time = hash
          let json = success.risk.all[success.risk.all.length - 1]
          for (let key in json) {
            series.push([key, json[key]])
          }
          let json1 = success.risk.all[success.risk.all.length - 2]
          for (let key in json1) {
            series1.push([key, json1[key]])
          }
          let json2 = success.risk.all
          json2.map((item, index) => {
            // 排序
            const ordered = {}
            Object.keys(item).sort((a, b) => new Date(b) - new Date(a)).forEach(function (key) {
              ordered[key] = item[key]
            })
            // 获取实际曲线数组
            for (let i in ordered) {
              series2[index] = [i, ordered[i]]
            }
          })
          this.series.push(
            {
              name: '当前预测曲线',
              type: 'line',
              data: series,
              connectNulls: true,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2,
                    type: 'dashed'
                  }
                }
              }
            },
            {
              name: '上次预测曲线',
              type: 'line',
              data: series1,
              connectNulls: true,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2,
                    type: 'dashed'
                  }
                }
              }
            },
            {
              name: '实际检测曲线',
              type: 'line',
              data: series2,
              connectNulls: true
            }
          )
        } else {
          time = (Object.keys(success.risk.all[0])).reverse()
          time.sort((a, b) => new Date(a) - new Date(b))
          for (let i = 0; i < time.length; i++) {
            if (hash.indexOf(time[i]) * 1 === -1) {
              hash.push(time[i])
            }
          }
          this.time = hash
          let json = success.risk.all[0]
          for (let key in json) {
            series.push([key, json[key]])
          }
          series2.push(series[0])
          this.series.push(
            {
              name: '当前预测曲线',
              type: 'line',
              data: series,
              connectNulls: true,
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2,
                    type: 'dashed'
                  }
                }
              }
            },
            {
              name: '实际检测曲线',
              type: 'line',
              data: series2,
              connectNulls: true
            }
          )
        }
        this.drawChart()
      })
    },
    drawChart () {
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))

      // // 整合数据
      // let xList = []
      // let yList = []
      // for (let i in that.list.risk) {
      //   xList.push(i)
      //   yList.push(that.list.risk[i])
      // }

      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: that.time
        },
        yAxis: {
          name: '%',
          type: 'value',
          nameGap: 5
        },
        legend: {
          data: ['当前预测曲线', '上次预测曲线', '实际检测曲线']
        },
        grid: {
          top: 50,
          bottom: 50,
          right: 15
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          left: '9%',
          bottom: -5,
          start: 10,
          end: 90 // 初始化滚动条
        }],
        series: this.series
      })

      window.onresize = myChart.resize
    },
    goToReview () {
      Dialog.confirm({
        message: '重新测评将放弃现有结果并重新计算\n' +
          '是否确认重新测评？'
      }).then(() => {
        // on confirm
        this.util.get(this.api.assessment_again_review, '', (success) => {
          this.$router.push('/assessmentAppraisal')
        })
      }).catch(() => {
        // on cancel
      })
    }
  },
  mounted () {
    this.getDetail()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";

  .assessment_resultDetail {
    padding: pxToRem(30px);

    .assessment_resultDetail_header {
      margin-bottom: pxToRem(20px);

      .assessment_resultDetail_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(60px);
        line-height: pxToRem(60px);
      }
    }

    .assessment_resultDetail_main {
      padding: pxToRem(40px);
      background-color: #fff;
      border-radius: pxToRem(30px);

      .title {
        color: #000;
        font-size: pxToRem(30px);
        margin-bottom: pxToRem(40px);
      }

      .myChart {
        width: 100%;
        height: 200px;
        margin-bottom: pxToRem(20px);
      }

      .state {
        text-align: center;
        font-size: pxToRem(25px);
        margin-bottom: pxToRem(40px);
        color: #000;

        span {
          display: inline-block;
          margin-right: pxToRem(40px);
          color: #FF0000;
          font-size: pxToRem(35px);
        }
      }

      .message {
        font-size: pxToRem(25px);
        color: #000;
        text-align: justify;
      }

      .btnBox {
        margin-bottom: pxToRem(20px);
      }

      .review {
        text-align: right;
        color: #0ba2cd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/assessment/resultDetail.vue